module.exports = __webpack_public_path__ + "static/img/14000296.7edf6464.png";